export default "__VITE_PUBLIC_ASSET__69006eb1__"